// REACT IMPORTS
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import RequestAccessForm from "components/auth/RequestAccessForm";
import QuestionsFooter from "components/auth/QuestionsFooter";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";
import { accountDetailsGet, useAccountDetails } from "store/slices/authSlice";
import { useAppDispatch } from "store/hooks";
import { decode } from "utils/HelperFunctions";
import { SettingsValue } from "types/payments";

/* ------------------------------------- REQUEST ACCESS PAGE ------------------------------------- */

const RequestAccess = () => {
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const dispatch = useAppDispatch();
  const accountDetails = useAccountDetails();

  useEffect(() => {
    if (!accountDetails?.data && clusterId) {
      dispatch(accountDetailsGet({ cluster_id: clusterId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusterId]);

  // Companies with request access disabled should not expose this form
  if (
    accountDetails?.data &&
    accountDetails?.data?.request_access !== SettingsValue.YES
  ) {
    return <Navigate to={`/${cluster_id}/login`} replace={true} />;
  }

  return (
    <>
      <Helment />
      <TestIdScope scope="auth-request-access">
        <div
          data-testid="auth-request-access-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex flex-col lg:flex-row lg:justify-center relative animate__animated animate__fadeIn"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 h-full w-full flex flex-col items-center justify-between lg:overflow-y-auto">
            <div className="lg:pt-[134px] p-5 w-full flex justify-center">
              <RequestAccessForm />
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default RequestAccess;
